import classNames from 'classnames'
import React from 'react'
import { PortableTextBodyElement } from '../../utilities/blockContent'
import { isNullOrWhiteSpace } from '../../utilities/string'
import { MarketSection } from '../MarketSection'
import { Paragraph } from '../Paragraph'
import { RichTextArea } from '../PortableText/RichTextArea'

export interface PageIntroProps {
  body?: PortableTextBodyElement[]
  id?: string
  preamble?: string
  rightColumnContent?: JSX.Element
  rightColumnHiddenOnSmallScreens?: boolean
  title?: string
}

export const PageIntro = ({
  body,
  id,
  preamble,
  rightColumnContent,
  rightColumnHiddenOnSmallScreens,
  title,
}: PageIntroProps) => (
  <MarketSection additionalClassName="gap-y-60" id={id}>
    <div
      className={classNames(
        'col-span-full flex flex-col gap-30',
        'tb:mx-90',
        'sm:col-start-2 sm:col-span-4 sm:mx-0',
        'md:col-start-1 md:col-span-3 md:mr-30',
        'lg:col-start-2 lg:col-span-3 lg:-ml-75 lg:mr-90',
        'xl:col-start-2 xl:col-span-4 xl:-ml-45 xl:mr-60',
        'xxl:col-start-4 xxl:col-span-4'
      )}
    >
      {!isNullOrWhiteSpace(title) && (
        <h2 className="font-h2 text-h2 text-secondary-dark">{title}</h2>
      )}

      {!isNullOrWhiteSpace(preamble) && (
        <Paragraph className="font-preamble text-preamble text-secondary-darker">
          {preamble}
        </Paragraph>
      )}

      {body && (
        <div>
          <RichTextArea value={body} />
        </div>
      )}
    </div>

    {rightColumnContent && (
      <div
        className={classNames(
          {
            'hidden md:block': rightColumnHiddenOnSmallScreens,
          },
          'col-span-full',
          'sm:mx-120',
          'md:col-start-4 md:col-span-3 md:ml-30 md:mr-0',
          'lg:col-start-5 lg:col-span-3 lg:-mr-75',
          'xl:col-start-6 xl:col-span-4',
          'xxl:col-start-8 xxl:col-span-4'
        )}
      >
        {rightColumnContent}
      </div>
    )}
  </MarketSection>
)
